import { format } from 'date-fns';

/** Default mask for card last digits in the customer-facing dashboards. */
export const CARD_DIGITS_MASK = '••••';

type MaskCardDigitsOptions = {
  /** Mask glyph shown before the digits. Payments dashboard uses `****`; customers use `••••`. */
  mask?: string;
  /** Returned when there are no digits to show. */
  fallback?: string;
};

/** Formats card last digits as a masked string, e.g. `•••• 7210`. */
export function formatMaskedCardDigits(
  lastDigits: string | null | undefined,
  { mask = CARD_DIGITS_MASK, fallback = '' }: MaskCardDigitsOptions = {},
): string {
  return lastDigits ? `${mask} ${lastDigits}` : fallback;
}

/** `MMM d, yyyy` — the dashboards' canonical short date. Accepts a Date or ISO string. */
export function formatShortDate(value: Date | string): string {
  return format(new Date(value), 'MMM d, yyyy');
}

/** `h:mm a` — the dashboards' canonical short time. */
export function formatShortTime(value: Date | string): string {
  return format(new Date(value), 'h:mm a');
}

/** `MM/yy` — card expiry format. */
export function formatCardExpiry(value: Date | string): string {
  return format(new Date(value), 'MM/yy');
}
